// setInterval(() => {
//   document.querySelectorAll(".develic-loaded").forEach((element) => {
//     if (!element.classList.contains("page-width")) {
//       element.classList.add("page-width");
//     }
//   });
// }, 100);

// function openModal(locationData) {
//   alert(JSON.stringify(locationData));
// }


function openModal(locationData) {
  const popup = document.createElement("div");
  popup.classList.add("popup-container");
  document.body.appendChild(popup);
  popup.innerHTML = `
    <div class="store-popup-content">
      <div class="leftSection">
        <div class="imageWithTitle">
          <div class="imageBlock">
            <img
              src="https://cdn.shopify.com/s/files/1/0275/3157/5355/files/NEW-PFF-Website-Sections-Design-OCT-24.png?v=1731246298"
              width="100%"
            >
          </div>
          <h3>${locationData.city}</h3>
        </div>
        <div class="locationContent">
          <div class="subHeading">Designer Dress Hire</div>
          <div class="iconWithText">
            <span class="iconBlock" style="width:20px">
              <img src="https://cdn.shopify.com/s/files/1/0275/3157/5355/files/location-pin.png?v=1731248043">
            </span>
            <span class="text">
              <p>Address: ${locationData.address}</p>
              <p>City: ${locationData.city}</p>
            </span>
          </div>
          <div class="iconWithText">
            <span class="iconBlock">
              <img src="https://cdn.shopify.com/s/files/1/0275/3157/5355/files/link.png?v=1731257132" width="42px">
            </span>
            <span class="text"> We can add info here about the type of products available to try on. </span>
          </div>
          <div class="iconWithText" >
            <span class="iconBlock" style="width:20px">
              <img src="https://cdn.shopify.com/s/files/1/0556/1614/3653/files/svgviewer-output_10.svg?v=1731612488" >
            </span>
            <span class="text">
              <p>Open On</p>
              ${
                locationData.openingTime.Monday
                  ? `<p>Monday: ${locationData.openingTime.Monday}</p>`
                  : ""
              }
              ${
                locationData.openingTime.Tuesday
                  ? `<p>Tuesday: ${locationData.openingTime.Tuesday}</p>`
                  : ""
              }
              ${
                locationData.openingTime.Wednesday
                  ? `<p>Wednesday: ${locationData.openingTime.Wednesday}</p>`
                  : ""
              }
              ${
                locationData.openingTime.Thursday
                  ? `<p>Thursday: ${locationData.openingTime.Thursday}</p>`
                  : ""
              }
              ${
                locationData.openingTime.Friday
                  ? `<p>Friday: ${locationData.openingTime.Friday}</p>`
                  : ""
              }
              ${
                locationData.openingTime.Saturday
                  ? `<p>Saturday: ${locationData.openingTime.Saturday}</p>`
                  : ""
              }
              ${
                locationData.openingTime.Sunday
                  ? `<p>Sunday: ${locationData.openingTime.Sunday}</p>`
                  : ""
              }
            </span>
          </div>
        </div>
      </div>
      <div class="rightSection">
        <h2>Try On Appointment</h2>
        <div class="appointmentInfo">
          <span class="text">Appointment length:</span>
          <span class="time">30 min</span>
        </div>
        <div class="description">
          We can add info here. There is a maximum of 8 dresses per try on period. If you would like an hour, or you and
          your friend want to try on dresses together - you will need to boook two try-on slots.
        </div>
        <div class="form-container">
        <form method="post" action="/contact#form-id-template--23658139058469__main" id="form-id-template--23658139058469__main" accept-charset="UTF-8" class="contact-form">
        <input type="hidden" name="form_type" value="contact">
        <input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="subject" value="Try On">

            <div class="form-row">
              <div class="form-group">
                <input type="text" id="firstName" name="firstName" placeholder="First name" required>
              </div>
              <div class="form-group">
                <input type="text" id="lastName" name="lastName" placeholder="Last name" required>
              </div>
            </div>
    
            <div class="form-group">
              <input type="email" id="email" name="email" placeholder="Email" required>
            </div>
    
            <div class="form-group">
              <input type="tel" id="phone" name="phone" placeholder="Phone" required>
            </div>
    
             <div class="form-group datetime-local">
        <input type="text"  name="datetime" placeholder="Select a date & time"  id="datetimepicker" required>
      </div>

      <div class="form-group datetime-local">
      
        <input type="text"  name="addresslocation"  value ="${locationData.location}" placeholder="address"  id="location" required style="display: none;">
      </div>
      <div class="form-group datetime-local">
      
        <input type="text"  name="address"  value ="${locationData.address}" placeholder="address"  id="location" required required style="display: none;">
      </div>
       <div class="form-group datetime-local">
        <input type="text"  name="addresscity"  value ="${locationData.city}" placeholder="address"  id="location" required required style="display: none;">
      </div>
    
            <button type="submit" class="submit-btn">REQUEST TO TRY ON</button>
            <span id="status"></span>
          </form>
        </div>
      </div>
    </div>
    `;
  $("body").addClass("overflow-hidden");
  $("#datetimepicker").datetimepicker({
    dateFormat: "yy-mm-dd",
    timeFormat: "HH:mm",
  });
  popup.onclick = function (event) {
    if (event.target === popup) {
      popup.remove();
      $("body").removeClass("overflow-hidden");
    }
  };
  document.getElementById("closePopup").onclick = function () {
    popup.remove();
  };

}

// window.mobileCheck = function () {
//   let check = false;
//   (function (a) {
//     if (
//       /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
//         a
//       ) ||
//       /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
//         a.substr(0, 4)
//       )
//     )
//       check = true;
//   })(navigator.userAgent || navigator.vendor || window.opera);
//   return check;
// };
// // Run the check
// if (!window.mobileCheck()) {
//   document.querySelector(
//     ".popup-content .form-group.datetime-local input:before"
//   ).style.content = "none";
// }
// document.getElementById("myForm").addEventListener("submit", function (event) {
//   event.preventDefault();
//   // Retrieve form data
//   const formData = new FormData(this);
//   const data = {
//     firstName: formData.get("firstName"),
//     lastName: formData.get("lastName"),
//     email: formData.get("email"),
//     phone: formData.get("phone"),
//     datetime: formData.get("datetime"),
//   };

//   // Display form data in console (can be replaced with an AJAX request)
//   console.log(data);
//   alert("Form submitted successfully!");
// });
